"use client";

import styled from "styled-components";
import { textColorPrimary, textColorSecondary, textColorTertiary } from "@churchofjesuschrist/eden-style-constants";
import { Text4 } from "@churchofjesuschrist/eden-text";
import { jsx as _jsx } from "react/jsx-runtime";
export const InternalUseOnlyLabel = styled(Text4).withConfig({
  componentId: "sc-8e6q3s-0"
})(["color:", ";&:has(input[type=\"checkbox\"],input[type=\"radio\"]){color:", ";}&:has(input[type=\"checkbox\"]:disabled,input[type=\"radio\"]:disabled){color:", ";cursor:not-allowed;}"], textColorSecondary, textColorPrimary, textColorTertiary);

/**
 * The `Label` represents a caption for an item in a user interface.
 * @param {object} props - The component props
 * @param {string} [props.htmlFor] - Indicates the id of the form element that the label describes
 * @param {React.ReactNode} props.children - Content to render inside the Label Component
 * @returns {React.ReactElement} The Label component.
 */
const Label = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/_jsx(InternalUseOnlyLabel, {
    renderAs: "label",
    ...props,
    children: children
  });
};
Label.displayName = "Label";
export default Label;